var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "data-table management-main-list-data-table" },
    [
      _c(
        "div",
        { staticClass: "management-add-button-container" },
        [_vm._t("default")],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "management-section-wrapper" },
        [
          _c(
            "v-card-title",
            [
              _c("span", { staticClass: "management-section-title" }, [
                _vm._v(_vm._s(_vm.$t("ListsSettings")))
              ]),
              _vm._v(" "),
              _c("v-spacer"),
              _vm._v(" "),
              _c("v-text-field", {
                staticClass: "data-table-search",
                attrs: {
                  value: _vm.searchFromParent,
                  "append-icon": "search",
                  label: _vm.$t("Search"),
                  placeholder: _vm.$t("Search"),
                  "single-line": "",
                  "hide-details": ""
                },
                on: { input: _vm.updateSearchInParent }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("v-data-table", {
            class: { "no-show-permission": !_vm.userHasPermissionTo("show") },
            attrs: {
              headers: _vm.headers,
              items: _vm.lists,
              search: _vm.searchFromParent,
              loading: _vm.loading,
              "loading-text": "",
              page: _vm.pagination.page,
              "items-per-page": _vm.paginationSettings.rowsPerPage,
              "items-per-page-text": _vm.rowsPerPageText,
              "items-per-page-items": _vm.rowsPerPageItems,
              "header-props": { sortIcon: _vm.sortIcon },
              "footer-props": {
                prevIcon: _vm.prevIcon,
                nextIcon: _vm.nextIcon,
                "items-per-page-options": _vm.rowsPerPageItems
              }
            },
            on: {
              "update:page": function($event) {
                return _vm.$set(_vm.pagination, "page", $event)
              },
              "update:itemsPerPage": function($event) {
                return _vm.$set(_vm.paginationSettings, "rowsPerPage", $event)
              },
              "update:items-per-page": function($event) {
                return _vm.$set(_vm.paginationSettings, "rowsPerPage", $event)
              },
              pagination: function($event) {
                return _vm.setRowsOnLocalStorage(
                  _vm.dataTableSettingsListId,
                  _vm.paginationSettings.rowsPerPage
                )
              }
            },
            scopedSlots: _vm._u([
              {
                key: "item",
                fn: function(props) {
                  return [
                    _c(
                      "tr",
                      {
                        class: {
                          "cursor-pointer": _vm.userHasPermissionTo("show")
                        },
                        on: {
                          click: function($event) {
                            return _vm.readList(
                              props.item,
                              props.item.custom_list
                            )
                          }
                        }
                      },
                      [
                        _vm.isSuperAdmin
                          ? _c("td", [_vm._v(_vm._s(props.item.code))])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(props.item.name))]),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(props.item.client_label))]),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(props.item.definition))]),
                        _vm._v(" "),
                        _vm.isSuperAdmin
                          ? _c(
                              "td",
                              [
                                !props.item.hidden
                                  ? _c(
                                      "v-layout",
                                      {
                                        attrs: { row: "", "align-center": "" }
                                      },
                                      [
                                        _c("div", {
                                          staticClass:
                                            "company-status-icon mr-3"
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              "text-transform": "lowercase"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(_vm.$t("No")) +
                                                "\n              "
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  : _c(
                                      "v-layout",
                                      {
                                        attrs: { row: "", "align-center": "" }
                                      },
                                      [
                                        _c("div", {
                                          staticClass:
                                            "company-status-icon status-inactive mr-3"
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              "text-transform": "lowercase"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(_vm.$t("Yes")) +
                                                "\n              "
                                            )
                                          ]
                                        )
                                      ]
                                    )
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "td",
                          [
                            !props.item.custom_list
                              ? _c(
                                  "v-layout",
                                  { attrs: { row: "", "align-center": "" } },
                                  [
                                    _c("div", {
                                      staticClass:
                                        "company-status-icon status-inactive mr-3"
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          "text-transform": "lowercase"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(_vm.$t("No")) +
                                            "\n              "
                                        )
                                      ]
                                    )
                                  ]
                                )
                              : _c(
                                  "v-layout",
                                  { attrs: { row: "", "align-center": "" } },
                                  [
                                    _c("div", {
                                      staticClass: "company-status-icon mr-3"
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          "text-transform": "lowercase"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(_vm.$t("Yes")) +
                                            "\n              "
                                        )
                                      ]
                                    )
                                  ]
                                )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        props.item.custom_list
                          ? _c(
                              "td",
                              [
                                _c("app-datatable-action-buttons", {
                                  attrs: {
                                    "user-can-edit": _vm.canEditList(true),
                                    "user-can-delete": _vm.canDelete
                                  },
                                  on: {
                                    edit: function($event) {
                                      return _vm.editItem(
                                        props.item,
                                        props.item.custom_list
                                      )
                                    },
                                    delete: function($event) {
                                      return _vm.askConfirmationToDeleteItem(
                                        props.item
                                      )
                                    }
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        !props.item.custom_list
                          ? _c(
                              "td",
                              [
                                _c("app-datatable-action-buttons", {
                                  attrs: {
                                    "user-can-edit": _vm.canEditList(false),
                                    "user-can-delete": false
                                  },
                                  on: {
                                    edit: function($event) {
                                      return _vm.editItem(
                                        props.item,
                                        props.item.custom_list
                                      )
                                    },
                                    delete: function($event) {
                                      return _vm.askConfirmationToDeleteItem(
                                        props.item
                                      )
                                    }
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e()
                      ]
                    )
                  ]
                }
              },
              {
                key: "pageText",
                fn: function(item) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(item.pageStart) +
                        " - " +
                        _vm._s(item.pageStop) +
                        " " +
                        _vm._s(_vm.$t("tables.Of")) +
                        "\n        " +
                        _vm._s(item.itemsLength) +
                        "\n      "
                    )
                  ]
                }
              },
              {
                key: "no-results",
                fn: function() {
                  return [
                    _c("data-table-no-results", {
                      attrs: { search: _vm.searchFromParent }
                    })
                  ]
                },
                proxy: true
              },
              {
                key: "no-data",
                fn: function() {
                  return [
                    _vm.loading
                      ? _c("div")
                      : _c(
                          "v-alert",
                          {
                            staticClass: "data-table-no-data",
                            attrs: { icon: "warning" }
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.$t("NoDataLists")) +
                                "\n        "
                            )
                          ]
                        )
                  ]
                },
                proxy: true
              }
            ])
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("app-dialog-box", {
        attrs: {
          open: _vm.deleteDialog,
          title: _vm.$t("Delete Custom List"),
          content:
            _vm.$t("DeleteConfirmation") + " " + _vm.itemToDelete.name + "?",
          "main-action-label": _vm.$t("No"),
          "secondary-action-label": _vm.$t("Yes"),
          loading: _vm.loadingDelete
        },
        on: { mainAction: _vm.cancelDelete, secondaryAction: _vm.deleteField }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fb38f54e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fb38f54e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SystemManagement/SystemSettings/ListsSettings/AllListsDataTable.vue
// module id = null
// module chunks = 